import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { FcisRateInfo } from 'src/app/shared/financing/finance.models';
import { fromMq } from 'src/app/store/common/common.selectors';

import { TrackingDirective } from '../../../core/services/tracking/directive/tracking.directive';

export enum WbPriceSize {
  S = 's',
  M = 'm',
  L = 'l'
}

@Component({
  selector: 'cc-finance-display',
  templateUrl: './finance-display.component.html',
  styleUrl: './finance-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TrackingDirective, AsyncPipe]
})
export class FinanceDisplayComponent {
  @Input() public fcisRateInfo!: FcisRateInfo;
  @Input() public showFinancialCalculatorOpener = false;
  @Input() public size = WbPriceSize.S;
  @Input() public textCentralizeOnMobile = false;

  @Output('openFinancialCalculator') public readonly openFinancialCalculator: EventEmitter<void> =
    new EventEmitter<void>();

  public readonly isMobile$: Observable<boolean> = this.store.select(fromMq.selectIsMq3Max);

  public constructor(private readonly store: Store) {}

  public openFinanceCalculator(): void {
    this.openFinancialCalculator.emit();
  }
}
